import React from 'react'

import XRay from '../Providers/XRay'

const XRayDrawer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : null
  const loadXRay =
    currentUrl &&
    (currentUrl.includes('dev.zipjob.com') ||
      currentUrl.includes('staging.zipjob.com') ||
      // currentUrl.includes('dev.topresume.com') ||
      currentUrl.includes('dev.topcv.com') ||
      currentUrl.includes('dev.topcv.co.uk'))

  if (loadXRay) {
    return <XRay>{children}</XRay>
  } else {
    return <React.Fragment>{children}</React.Fragment>
  }
}

export default XRayDrawer
